import React, { useRef } from 'react'
import { OverlayPanel } from 'primereact/overlaypanel'

import { Button } from '../../../helpers'

import "../index.css"


const DeletePI = (props) => {
    const { handleDelete, handleDeleteGRN, sellerPIPunch, sellerGRNQCPunch, canEditable } = props
    const op = useRef(null)

    return (
        <>
            <div className='delete-pi-punch-container' style={{ position: "relative"}}>
                <Button className="trash-btn" icon="pi pi-trash" rounded severity="danger" disabled={props?.forViewOnly || sellerPIPunch?.statusId === 2} permissions={canEditable ? [] : [21]} onClick={(e) => op.current.toggle(e)} />
                <OverlayPanel ref={op} className="overlay-panel deletepi-overlaypanel p-2 mt-3" style={{ minHeight: "3rem", minWidth: "120px", position:"", top: "100%", left: "0", transform: "none"}} appendTo="self" pt={{
                    root: { style: { top: "100%", left: "0", position: "fixed" , transform: "none" } }
                }}>
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"space-between", position:""}}>
                        <Button className="small-btn mb-1" label="Delete PI Punch" text onClick={() => handleDelete(sellerPIPunch.sellerPIPunchId)} permissions={[21]} applyThrottle />
                        {
                            (sellerGRNQCPunch?.length > 0 && sellerPIPunch?.statusId === 1) &&
                            <Button className="small-btn mb-1" label="Reverse GRN" text onClick={() => handleDeleteGRN(sellerPIPunch?.sellerPIPunchId)} permissions={[149]}/>
                        }
                        <Button className="small-btn mb-1" label="Cancel" text onClick={e => op.current.toggle(e)}/>
                    </div>
                </OverlayPanel>
            </div>
        </>
    )
}

export default DeletePI